import { Component, NgZone } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AutoUnsubscribe } from 'src/app/core/auto-unsubscribe';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})

@AutoUnsubscribe()
export class HeaderComponent {

    constructor(private router: Router) {

        //페이지 이동시 전체메뉴 닫아주기
        router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe((ev: NavigationEnd) => {
                setTimeout(() => {
                    page.collection();
                    mainHeaderFun();
                },400);
        })
    }


    ngOnInit() {
        setTimeout(() => {
            common();
            page.gnb.onLoad();
            page.header.scrollHead();
            // page.footer.familySite();
        }, 300);
        setTimeout(() => {
            $(window).on('scroll', function () {
                page.header.scrollHead();
            });
        }, 350);
    }

}
declare var common: any;
declare var mainHeaderFun: any;
declare var page: any;
declare var $: any;

